import React, { useEffect, useState } from 'react';
import { css, Theme } from '@emotion/react';
import { useParams } from 'react-router';
import { stroot, organisation as organisationAPI } from '@birdi/js-sdk';
import { useMetaSelector, updateOrganisation } from '../meta/reducer';
import { useDispatch } from 'react-redux';
import { buttonBlue, blocks, forms } from '@birdi/theme';
import * as Toast from '@radix-ui/react-toast';
import * as styles from '../administration/styles';
import HandsSVG from '@birdi/icons/thank-you.svg';

interface Fields {
  name: string;
  url: string;
}

const General = () => {
  const { orgId } = useParams<{ orgId: string }>();

  const dispatch = useDispatch();
  const meta = useMetaSelector();
  const [orgName, setOrgName] = useState('');
  const [toastOpen, setToastOpen] = React.useState(false);

  const currentOrg = meta.organisation.id === orgId;

  useEffect(() => {
    if (!orgId) return;
    organisationAPI.getOneById(stroot('iy3ohb'), orgId).then((res) => {
      setOrgName(res.body.name);
    });
  }, [orgId]);

  const updateFields = async (fieldsToUpdate: Fields) => {
    if (!orgId) return;
    await organisationAPI.updateBranding(
      stroot('iy3ohb'),
      orgId,
      fieldsToUpdate,
    );
    if (currentOrg) dispatch(updateOrganisation(fieldsToUpdate));
  };

  return (
    <div>
      <div css={blocks.pageTitleHolder}>
        <h2 css={blocks.pageTitle}>
          General &nbsp;&nbsp;
          <span
            css={(theme) => css`
              color: ${theme.mono40};
            `}
          >
            {orgName}
          </span>
        </h2>
      </div>
      <div css={blocks.pageGraySection}>
        <p>Manage your workspace information.</p>
      </div>
      <div
        css={css`
          padding: 1em;
          max-width: 35em;
        `}
      >
        <p>Workspace name</p>
        <div
          css={css`
            display: flex;
            flex-direction: row;
          `}
        >
          <input
            css={(theme) => css`
              ${forms.textInput(theme)};
              margin-right: 1em;
              max-width: 25em;
            `}
            type="text"
            id="orgName"
            defaultValue={orgName}
            onChange={(event) => setOrgName(event.target.value)}
          />
        </div>
        <Toast.Provider>
          <button
            type="button"
            css={(theme) => css`
              ${buttonBlue(theme)};
              height: 2.5em;
              margin-top: 1em;
            `}
            onClick={() => {
              updateFields({ name: orgName });
              setToastOpen(true);
              window.setTimeout(() => setToastOpen(false), 2000);
            }}
            disabled={!orgName}
          >
            Save changes
          </button>
          <Toast.Root css={styles.toastRoot} open={toastOpen}>
            <Toast.Description css={styles.toastContent}>
              <HandsSVG />
              Workspace name updated
            </Toast.Description>
          </Toast.Root>
          <Toast.Viewport css={styles.toastViewport} />
        </Toast.Provider>
      </div>
    </div>
  );
};

export default General;
